export default __webpack_public_path__ + "static/media/apartment-placeholder.0989fd6e.svg";